export const DEFAULT_TABLE_CONFIG = {
  page: 1,
  pageSize: 10,
  orderBy: 'id',
  sortDesc: true,
  sorting: 'descending',
  filter: '',
};
